export { default as Img200 } from './processed/200/StationAgent.jpg';
export { default as Img400 } from './processed/400/StationAgent.jpg';
export { default as Imgthumb } from './processed/thumb/StationAgent.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/StationAgent.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/StationAgent.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      18,
      169,
      224
    ],
    "_population": 27,
    "_hsl": [
      0.5444983818770227,
      0.8512396694214877,
      0.4745098039215686
    ]
  },
  "LightVibrant": {
    "_rgb": [
      140,
      204,
      236
    ],
    "_population": 1,
    "_hsl": [
      0.5555555555555556,
      0.7164179104477613,
      0.7372549019607844
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      8,
      68,
      97
    ],
    "_population": 1373,
    "_hsl": [
      0.5543071161048689,
      0.8476190476190476,
      0.20588235294117646
    ]
  },
  "Muted": {
    "_rgb": [
      117,
      138,
      148
    ],
    "_population": 2378,
    "_hsl": [
      0.5537634408602151,
      0.12653061224489803,
      0.5196078431372549
    ]
  },
  "LightMuted": {
    "_rgb": [
      160,
      185,
      204
    ],
    "_population": 1050,
    "_hsl": [
      0.571969696969697,
      0.3013698630136987,
      0.7137254901960784
    ]
  },
  "DarkMuted": {
    "_rgb": [
      69,
      83,
      86
    ],
    "_population": 2677,
    "_hsl": [
      0.5294117647058824,
      0.10967741935483877,
      0.303921568627451
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/StationAgent.js